export default __webpack_public_path__ + "static/media/amfb.2dfcdb91.png";